import React, { FunctionComponent } from "react";

import { Checkbox } from "../../ui/Checkbox/Checkbox";
import { useAccesssoryCategories } from "./Filters/Category/useAccesssoryCategories";
import { useCategoryOptions } from "./Filters/Category/useCategoryOptions";

const translations = new Set(["popular", "populaire"]);

export const AccessoryQuickFilters: FunctionComponent = () => {
  const options = useCategoryOptions();
  const popularOption = options.find(({ name }) =>
    translations.has(String(name).toLowerCase())
  );
  const [, { set }] = useAccesssoryCategories();
  if (!popularOption) {
    return null;
  }
  const otherSelectedOptions = options.filter(
    ({ checked, value }) => checked && value !== popularOption.value
  );
  return (
    <label className="flex gap-2 items-center text-sm whitespace-nowrap">
      <Checkbox
        onChange={(): void => {
          set(popularOption.checked ? null : popularOption.value);
        }}
        checked={popularOption.checked}
      />
      {popularOption.name}
      {Boolean(otherSelectedOptions.length) &&
        ` +${otherSelectedOptions.length}`}
    </label>
  );
};
